export default "__VITE_ASSET__IQXyMoiY__"